import { Directive, HostListener, OnDestroy } from "@angular/core";
import { NotificationsService } from "../services/notifications.service";
import { UserService } from "../services/user.service";
import { AssessmentService } from "../../assessment/shared/services/assessment.service";
import { Subscription } from "rxjs";

@Directive({
  selector: "[appBlockPrint]",
})
export class BlockPrintDirective implements OnDestroy {
  personId: string;
  private warnSubscription: Subscription;

  constructor(
    private notifications: NotificationsService,
    private userService: UserService,
    private assessmentService: AssessmentService
  ) {
    this.personId = this.userService.CurrentUser.personId;
  }

  @HostListener("window:beforeprint", ["$event"]) blockPrintBefore(e) {
    e.preventDefault();
    this.warnUserAboutPrinting();
  }

  private warnUserAboutPrinting(): void {
    this.warnSubscription = this.assessmentService
      .warnUser(this.personId, "print")
      .subscribe(
        () => {
          this.notifications.errorWithWait(
            "Warning",
            "Your key strokes are recorded by the system. Efforts to capture content could initiate an investigation of potential misconduct by the NBRC Judicial and Ethics Committee.",
            0
          );         
        },
        (err) => {
          console.error("Error warning user about printing:", err);
        }
      );
  }

  ngOnDestroy(): void {
    if (this.warnSubscription) {
      this.warnSubscription.unsubscribe();
    }
  }
}
